import InputFormField from '@shared/components/form/input-form-field';

interface TotalEmissionsFieldsProps {
  isEditMode: boolean;
}

export default function TotalEmissionsFields({
  isEditMode: _isEditMode,
}: TotalEmissionsFieldsProps) {
  return (
    <>
      <div className="grid grid-cols-12 gap-2">
        <InputFormField
          name="description"
          label="Description"
          className="col-span-12"
          includeErrorMessage
        />
      </div>
      <div className="grid grid-cols-12 gap-2">
        <InputFormField
          name="emissions"
          label="Emissions"
          unit="tCO2e"
          type="number"
          className="col-span-6"
          includeErrorMessage
        />
      </div>
    </>
  );
}
